<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Announcement</h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            @click="editOperation"
            :disabled="!editForm.name || !editForm.mediaFileId"
            >Save</el-button
          >
          <el-button type="default" @click="cancelOperation">Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <recent-audits service="Announcement" :record="selectedAnnouncement" />
      <div class="inline-form-group">
        <el-checkbox
          :value="editForm.active"
          @change="editForm.active = !editForm.active"
        >
          Active
        </el-checkbox>
      </div>

      <div class="inline-form-group">
        <el-input v-model="editForm.name" placeholder="Enter name*">
          <template slot="prefix"><span>Name</span></template>
        </el-input>
      </div>

      <el-input
        id="note"
        type="textarea"
        placeholder="Enter a description"
        v-model="editForm.description"
        :autosize="{ minRows: 4 }"
      />

      <dads-select v-model="editForm.branchId" placeholder="Branch" filterable>
        <template slot="prefix"> Branch</template>
        <el-option
          v-for="branch in branchOptions"
          :key="branch.id"
          :value="branch.id"
          :label="branch.name"
        />
      </dads-select>

      <div class="inline-form-group">
        <div class="flex column left">
          <h3 class="black-text">Announcement Dates</h3>
          <el-date-picker
            v-model="editForm.dateRange"
            style="margin-bottom: 20px"
            type="datetimerange"
            align="right"
            unlink-panels
            format="yyyy-MM-dd HH:mm"
            :clearable="false"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          />
          <el-tag type="primary" size="small">
            <i class="el-icon-info"></i>
            Date range applies to IVR announcements only
          </el-tag>
        </div>
      </div>

      <dads-select
        clearable
        filterable
        remote
        multiple
        placeholder="Select IVR"
        v-model="editForm.ivrIds"
        :remote-method="getIvrOptions"
      >
        <template slot="prefix"> IVR </template>
        <el-option
          v-for="{ id, name } in ivrOptions"
          :key="id"
          :label="`${name}`"
          :value="id"
        />
      </dads-select>

      <div class="inline-form-group">
        <hr />
      </div>

      <div class="inline-form-group">
        <existing-mediafile
          style="width: 100%"
          title="Media Files"
          :multiple="false"
          required="true"
          :clearState="clearFormFields"
          :newMediafile="newMediafile"
          :selectedMeId="editForm.mediaFileId"
          @mediafileSelected="editForm.mediaFileId = $event"
        />
      </div>

      <div class="inline-form-group">
        <announcements-new-mediafile @mediafileSaved="newMediafile = $event" />
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import NewMediafile from "@/components/NewMediafile";
import moment from "moment/moment";
import DadsSelect from "@/components/select";
import RecentAudits from "@/components/RecentAudits";
import AnnouncementsNewMediafile from "@/views/pages/announcements/components/announcements-new-media-file.vue";
import ExistingMediafile from "@/components/ExistingMediafile.vue";

export default {
  name: "AnnouncementsEditForm",

  props: {
    editVisible: { required: true },
    editProcessing: { required: true },
    clearFormFields: { required: true },
    selectedAnnouncement: { required: true },
    branchOptions: { required: true },
    ivrOptions: { required: true },
    getIvrOptions: { type: Function, required: true }
  },

  components: {
    ExistingMediafile,
    AnnouncementsNewMediafile,
    DadsSelect,
    NewMediafile,
    RecentAudits
  },

  data() {
    return {
      newMediafile: null,
      editForm: {
        tenantId: null,
        name: "",
        description: "",
        branchId: null,
        dateRange: [moment(), moment()],
        active: false,
        ivrIds: [],
        mediaFileId: null
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedAnnouncement(val) {
      if (val) {
        const {
          name,
          description,
          active,
          ivrs,
          mediaFile,
          startDate,
          endDate,
          branch
        } = val;
        this.editForm.name = name;
        this.editForm.description = description;
        this.editForm.active = !!active;
        this.editForm.branchId = branch.id;
        this.editForm.ivrIds = ivrs ? ivrs.map((ivr) => ivr.id) : [];
        this.editForm.mediaFileId = mediaFile.id;
        this.editForm.dateRange = [
          startDate ? moment(startDate) : moment(),
          endDate ? moment(endDate) : moment()
        ];

        // Populate ivrOptions with selected IVRs so their names display
        if (ivrs && ivrs.length > 0) {
          this.$emit("updateIvrOptions", ivrs);
        }
      }
    }
  },

  methods: {
    editOperation() {
      const editBody = { ...this.editForm };
      editBody.tenantId = this.selectedTenant.id;

      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.newMediafile = null;
      this.editForm = {
        tenantId: null,
        name: "",
        description: "",
        branchId: null,
        dateRange: [moment(), moment()],
        active: false,
        ivrIds: [],
        mediaFileId: null
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.inline-form-group .el-checkbox {
  margin-left: 0;
}
</style>
